import { roles } from "../../../common/constants";

export default {
  items: [
    {
      title: true,
      name: "Dashboard",
      wrapper: {
        // optional wrapper object
        element: "span", // required valid HTML5 element tag
        attributes: {}, // optional valid JS object with JS API naming ex: { className: 'my-class', style: { fontFamily: 'Verdana' }, id: 'my-id'}
      },
      class: "text-center", // optional class names space delimited list for title item ex: 'text-center'
    },
    {
      name: "Dashboard",
      url: "/dashboard",
      icon: "icon-speedometer",
    },
    {
      name: "Franquicia",
      url: "/franchise",
      icon: "icon-doc",
      roles: [roles.SUPER_ADMIN, roles.ACCOUNTANT],
    },
    {
      title: true,
      name: "Ventas",
      wrapper: {
        element: "span",
        attributes: {},
      },
      class: "text-center",
    },
    {
      name: "Ventas",
      url: "/remotesells",
      icon: "icon-speedometer",
    },
    {
      title: true,
      name: "Administración",
      wrapper: {
        element: "span",
        attributes: {},
      },
      class: "text-center",
    },
    {
      name: "Usuarios",
      url: "/administration/users",
      icon: "icon-people",
    },
    {
      name: "Tiendas",
      url: "/administration/stores",
      icon: "icon-bag",
    },
    {
      name: "Proveedores",
      url: "/administration/providers",
      icon: "icon-share-alt",
    },
    {
      name: "Categorías",
      url: "/administration/categories",
      icon: "icon-list",
    },
    {
      name: "Productos",
      url: "/administration/products",
      icon: "icon-layers",
    },
    {
      name: "Servicios",
      url: "/administration/services",
      icon: "icon-tag",
    },
    {
      name: "Ofertas",
      url: "/administration/offers",
      icon: "icon-tag",
    },
    {
      name: "Empleados",
      url: "/administration/employees",
      icon: "icon-people",
    },
    {
      name: "Clientes",
      url: "/administration/customers",
      icon: "icon-people",
    },
    {
      name: "Cotizaciones",
      url: "/administration/quotations",
      icon: "icon-doc",
    },
    {
      name: "Recompensas",
      url: "/administration/rewards",
      icon: "fa fa-certificate",
    },
    {
      name: "Noticias",
      url: "/administration/newsletters",
      icon: "fa fa-newspaper-o",
    },
    {
      title: true,
      name: "Reportes",
      wrapper: {
        element: "span",
        attributes: {},
      },
      class: "text-center",
    },
    {
      name: "Por Caja",
      icon: "icon-chart",
      children: [
        {
          name: "Caja Diaria",
          url: "/report/dailybalance",
          icon: "fa fa-circle",
        },
        // {
        //   name: "Caja por Empleados",
        //   url: "/report/employeesbalance",
        //   icon: "fa fa-circle",
        // },
        {
          name: "Reporte Detallado",
          url: "/report/detailedreport",
          icon: "fa fa-circle",
        },
      ],
    },
    {
      name: "Por Balance",
      icon: "icon-chart",
      roles: [roles.SUPER_ADMIN, roles.ADMIN],
      children: [
        {
          name: "Balance por Categorías",
          url: "/report/categorybalance",
          icon: "fa fa-circle",
        },
        {
          name: "Balance por Metodo de Pago",
          url: "/report/paymentbalance",
          icon: "fa fa-circle",
        },
        {
          name: "Balance por Recibo",
          url: "/report/receiptbalance",
          icon: "fa fa-circle",
        },
        {
          name: "Balance por Servicios",
          url: "/report/servicebalance",
          icon: "fa fa-circle",
        },
        {
          name: "Balance por Productos",
          url: "/report/productbalance",
          icon: "fa fa-circle",
        },
        {
          name: "Balance por Ofertas",
          url: "/report/offerbalance",
          icon: "fa fa-circle",
        },
        {
          name: "Balance por Dias",
          url: "/report/daysbalance",
          icon: "fa fa-circle",
        },
        {
          name: "Balance por Clientes",
          url: "/report/customersbalance",
          icon: "fa fa-circle",
        },
      ],
    },
    {
      name: "Por Movimientos",
      icon: "icon-chart",
      roles: [roles.SUPER_ADMIN, roles.ADMIN, roles.ACCOUNTANT],
      children: [
        {
          name: "Entrada de Producto",
          url: "/report/productsin",
          icon: "fa fa-circle",
        },
        {
          name: "Consumo Interno",
          url: "/report/internalconsumption",
          icon: "fa fa-circle",
        },
        {
          name: "Regularizaciones",
          url: "/report/regularizations",
          icon: "fa fa-circle",
        },
        {
          name: "Devoluciones al Proveedor",
          url: "/report/productsdevolutions",
          icon: "fa fa-circle",
        },
        {
          name: "Inventarios",
          url: "/report/inventory",
          icon: "fa fa-circle",
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/Sidebar/MainSidebar/_nav.js